// @flow
import React from 'react';
import {
  useSelector,
  useDispatch,
} from 'react-redux';

import type {
  Filters,
  FilterType,
  FilterOptions,
  Dispatch,
} from 'chronos-types';

import * as actions from 'chronos-actions';
import * as selectors from 'chronos-selectors';

import {
  Filter,
} from 'chronos-components';


const typeOptions: FilterOptions = [
  { label: 'Users', value: 'users' },
  { label: 'Projects', value: 'projects' },
  { label: 'Boards', value: 'boards' },
  { label: 'Issue types', value: 'issueTypes' },
  { label: 'Issue statuses', value: 'issueStatuses' },
  { label: 'Versions', value: 'versions' },
  { label: 'Epics', value: 'epics' },
  { label: 'Sprints', value: 'sprints' },
  { label: 'Worklog types', value: 'worklogTypes' },
  { label: 'Components', value: 'components' },
  { label: 'Custom JQL', value: 'jqlFilters' },
];

type Props = {
  filterType: FilterType,
  filterOptions: FilterOptions,
  filters: Filters,
  profileKey: string,
};

const mapState: Props = (state) => {
  const filterType = selectors.getFiltersType(state);
  return ({
    filterType,
    isOpen: selectors.getUiState('isFilterOpen')(state),
    profile: state.profile?.userData,
    filterOptions: (
      filterType
        ? selectors.getFiltersOptions(filterType)(state)
        : []
    ),
    filters: selectors.getFilters(state),
  });
};

const FilterContainer = () => {
  const {
    filterType,
    profile,
    filters,
    isOpen,
  } = useSelector(mapState);
  const dispatch: Dispatch = useDispatch();
  return (
    <Filter
      profile={profile}
      selectedType={filterType}
      selectedFilters={filters}
      typeOptions={typeOptions}
      isOpen={isOpen}
      loadOptions={(query, options) => (
        new Promise(
          resolve => (
            dispatch(actions.loadFilterOptionsRequest({
              filterType,
              query,
              loadedQty: options.length,
              resolve,
            }))
          ),
        )
      )}
      onTypeChange={({ value }) => {
        dispatch(actions.setFilterType(value));
      }}
      onVisibilityChange={(isFilterOpen) => {
        dispatch(actions.setUiState({
          isFilterOpen,
        }));
      }}
      onAdd={({ selectedType, option }) => {
        dispatch(actions.addFilter(option.value, selectedType));
      }}
      onRemove={({ selectedType, option }) => {
        dispatch(actions.removeFilter(option.value, selectedType));
      }}
    />
  );
};

export default FilterContainer;
